import React, { useMemo } from 'react';
import styles from './BackgroundElements.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const BackgroundElements = () => {
  const elements = useMemo(() => {
    const fixedElements = [
      {
        id: 1,
        type: 'coin1',
        animClass: 'animFloat',
        style: {
          top: '627px',
          left: '-30px',
          width: '70px',
          height: '71px',
          '--ty': '161px',
          '--rot': '108deg',
          '--duration': '6s'
        }
      },
      {
        id: 2,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '632px',
          right: '2px',
          width: '41px',
          height: '63px',
          '--ty': '230px',
          '--rot': '360deg',
          '--duration': '8s'
        }
      },
      {
        id: 3,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '563px',
          right: '174px',
          width: '41px',
          height: '63px',
          '--ty': '230px',
          '--rot': '360deg',
          '--duration': '8s'
        }
      },
      {
        id: 4,
        type: 'coin3',
        animClass: 'animFloatCoin3',
        style: {
          top: '749px',
          right: '74px',
          width: '57px',
          height: '57px',
          '--duration': '10s'
        }
      },
      {
        id: 5,
        type: 'ball',
        animClass: 'animFloatBall',
        style: {
          top: '721px',
          right: '186px',
          width: '18px',
          height: '18px',
          '--ty': '140px',
          '--duration': '10s'
        }
      },
      {
        id: 6,
        type: 'ball',
        animClass: 'animFloat',
        style: {
          top: '740px',
          left: '45px',
          width: '32px',
          height: '32px',
          '--ty': '140px',
          '--rot': '360deg',
          '--duration': '12s'
        }
      },
      {
        id: 7,
        type: 'ball',
        animClass: 'animFloat',
        style: {
          top: '1205px',
          left: '160px',
          width: '32px',
          height: '32px',
          '--ty': '100px',
          '--rot': '360deg',
          '--duration': '14s'
        }
      },
      {
        id: 8,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '1185px',
          right: '20px',
          width: '41px',
          height: '63px',
          '--ty': '230px',
          '--rot': '360deg',
          '--duration': '10s'
        }
      },
      {
        id: 9,
        type: 'coin1',
        animClass: 'animFloat',
        style: {
          top: '1110px',
          right: '108px',
          width: '70px',
          height: '71px',
          '--ty': '161px',
          '--rot': '180deg',
          '--duration': '7s'
        }
      },
      {
        id: 10,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '1021px',
          right: '80px',
          width: '41px',
          height: '63px',
          '--tx': '-140px',
          '--ty': '120px',
          '--start-rot': '45deg',
          '--rot': '-210deg',
          '--duration': '10s'
        }
      },
      {
        id: 11,
        type: 'coin3',
        animClass: 'animFloatCoin3Up',
        style: {
          top: '1221px',
          left: '-20px',
          width: '57px',
          height: '57px',
          '--duration': '15s'
        }
      },
      {
        id: 12,
        type: 'ball',
        animClass: 'animFloatBall12',
        style: {
          top: '1288px',
          left: '52px',
          width: '18px',
          height: '18px',
          '--ty': '110px',
          '--rot': '360deg',
          '--duration': '10s'
        }
      },
      {
        id: 13,
        type: 'coin3',
        animClass: 'animFloatCoin3Down',
        style: {
          top: '1446px',
          right: '33px',
          width: '57px',
          height: '57px',
          '--duration': '10s'
        }
      },
      {
        id: 14,
        type: 'ball',
        animClass: 'animFloatBall14',
        style: {
          top: '1718px',
          left: '50px',
          width: '18px',
          height: '18px',
          '--ty': '112px',
          '--rot': '360deg',
          '--duration': '10s'
        }
      },
      {
        id: 15,
        type: 'ball',
        animClass: 'animFloat',
        style: {
          top: '1885px',
          right: '43px',
          width: '32px',
          height: '32px',
          '--ty': '100px',
          '--rot': '360deg',
          '--duration': '12s'
        }
      },
      {
        id: 16,
        type: 'coin3',
        animClass: 'animFloatCoin3',
        style: {
          top: '2006px',
          right: '-10px',
          width: '57px',
          height: '57px',
          '--ty': '175px',
          '--duration': '14s'
        }
      },
      {
        id: 17,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '2236px',
          right: '174px',
          width: '41px',
          height: '63px',
          '--ty': '170px',
          '--rot': '190deg',
          '--duration': '8s'
        }
      },
      {
        id: 18,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '2521px',
          left: '102px',
          width: '41px',
          height: '63px',
          '--ty': '170px',
          '--rot': '190deg',
          '--duration': '8s'
        }
      },
      {
        id: 19,
        type: 'coin1',
        animClass: 'animFloat',
        style: {
          top: '2451px',
          left: '-15px',
          width: '70px',
          height: '71px',
          '--ty': '161px',
          '--rot': '108deg',
          '--duration': '8s'
        }
      },
      {
        id: 20,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '2928px',
          right: '20px',
          width: '41px',
          height: '63px',
          '--ty': '170px',
          '--rot': '190deg',
          '--duration': '8s'
        }
      },
      {
        id: 21,
        type: 'coin3',
        animClass: 'animFloatCoin3Up',
        style: {
          top: '2964px',
          left: '-15px',
          width: '57px',
          height: '57px',
          '--duration': '15s'
        }
      },
      {
        id: 22,
        type: 'coin3',
        animClass: 'animFloatCoin3Down',
        style: {
          top: '3189px',
          right: '28px',
          width: '57px',
          height: '57px',
          '--duration': '10s'
        }
      },
      {
        id: 23,
        type: 'coin2',
        animClass: 'animFloat',
        style: {
          top: '2764px',
          right: '80px',
          width: '41px',
          height: '63px',
          '--tx': '-140px',
          '--ty': '120px',
          '--start-rot': '45deg',
          '--rot': '-210deg',
          '--duration': '12s'
        }
      },
      {
        id: 24,
        type: 'coin3',
        animClass: 'animFloatCoin3Down',
        style: {
          top: '263px',
          right: '-10px',
          width: '57px',
          height: '57px',
          '--duration': '14s'
        }
      }
    ];

    return [...fixedElements.map((el, i) => ({ ...el, id: `fixed-${i}` }))];
  }, []);

  return (
    <div className={styles.backgroundContainer}>
      {elements.map((el) => (
        <img
          key={el.id}
          src={getImageFromS3(`images/sms-prlm-s/${el.type}.png`)}
          className={`${styles.element} ${styles[el.animClass]}`}
          style={el.style}
          alt={el.type}
        />
      ))}
    </div>
  );
};

export default BackgroundElements;
